const HOSTNAME = window.location.hostname

const getEnvironment = () => {
  if (HOSTNAME.startsWith('test') || HOSTNAME === 'localhost') {
    return 'test'
  }

  return 'prod'
}

const environment = getEnvironment()

const API_BASE_URLS = {
  test: 'https://test.xcars.kz',
  prod: 'https://xcars.kz'
}

export const isDevelop = false
export const BaseUrl = API_BASE_URLS[environment]

export const AUTH_API_URL = `${API_BASE_URLS[environment]}/api-auth`
export const CREDIT_FLOW_API_URL = `${API_BASE_URLS[environment]}/api-credit-flow`
export const CABINET_API_URL = `${API_BASE_URLS[environment]}/api-cabinet`
